// extracted by mini-css-extract-plugin
export default {"history__section":"style_history__section__9IB03","not_empty":"style_not_empty__aeJ31","history__container":"style_history__container__kxlIp","res__count":"style_res__count__Zi7lM"};